import {FC} from 'react'
import {Link} from 'react-router-dom'
import {useLayout} from '../core'

const Footer: FC = () => {
  const {classes} = useLayout()
  return (
    <footer className='footer py-4' id='kt_footer'>
      <div className={`${classes.footerContainer} education-footer-inner`}>
        <div className='education-footer-meta'>
          <span>© {new Date().getFullYear()} Okudemi</span>
          <span aria-hidden='true'>·</span>
          <span>Öğretmen paneli</span>
        </div>
        <Link to='/dashboard'>Sınıfıma dön <span aria-hidden='true'>→</span></Link>
      </div>
    </footer>
  )
}
export {Footer}
